import { Action, Module, VuexModule } from "vuex-module-decorators";
import { Banners } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class BannersModule extends VuexModule {
    @Action
    [Banners.findPageBanners](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.get( `/api/v1`,`banners?pageNum=${values.pageNum}&pageSize=${values.pageSize}`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Banners.findBannersById](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/api/v1`,`banners/${values}`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Banners.saveBanners](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/api/v1/banners/`, values,{headers: {'Content-Type':'multipart/form-data'}, onUploadProgress: onUploadProgress})
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Banners.updateBanners](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/api/v1/banners/${values.id}`, values.data,{headers: {'Content-Type':'multipart/form-data'}, onUploadProgress: onUploadProgress})
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Banners.deleteBannersById](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.delete(`/api/v1/banners/${values}`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Banners.uploadBannerImage](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/api/v1/banners/uploadImage`,values, {headers: {'Content-Type':'multipart/form-data'}})
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
}